import React from 'react';
import classroom from '../../assests/img/classroom.jpg';
import { Table } from 'react-bootstrap';
import { colors } from '@mui/material';

const Gallery = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Gallery</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Gallery
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <Table border="0" cellspacing="0" width="100%">
                                                    <tbody>
                                                        <tr className="Cell">
                                                            <td height="90" width="130" style={{
                                                                border: "1px solid #d3d3d3"
                                                            }}>
                                                                <a href="#" style={{ lineHeight: "20px" }}>
                                                                    <img border="0" height="90" width="130" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                </a>
                                                            </td>
                                                            <td height="90" style={{ border: "1px solid #d3d3d3", }}>
                                                                <a href="#" className="tgallery" style={{ lineHeight: "20px" }}>
                                                                    Playground
                                                                </a>
                                                                <br />
                                                                (5 Photos)
                                                            </td>
                                                        </tr>
                                                        <tr className="Cell">
                                                            <td height="90" width="130" style={{
                                                                border: "1px solid #d3d3d3"
                                                            }}>
                                                                <a href="#" style={{ lineHeight: "20px" }}>
                                                                    <img border="0" height="90" width="130" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                </a>
                                                            </td>
                                                            <td height="90" style={{ border: "1px solid #d3d3d3", }}>
                                                                <a href="#" className="tgallery" style={{ lineHeight: "20px" }}>
                                                                    Playground
                                                                </a>
                                                                <br />
                                                                (5 Photos)
                                                            </td>
                                                        </tr>
                                                        <tr className="Cell">
                                                            <td height="90" width="130" style={{
                                                                border: "1px solid #d3d3d3"
                                                            }}>
                                                                <a href="#" style={{ lineHeight: "20px" }}>
                                                                    <img border="0" height="90" width="130" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                </a>
                                                            </td>
                                                            <td height="90" style={{ border: "1px solid #d3d3d3", }}>
                                                                <a href="#" className="tgallery" style={{ lineHeight: "20px" }}>
                                                                    Playground
                                                                </a>
                                                                <br />
                                                                (5 Photos)
                                                            </td>
                                                        </tr>
                                                        <tr className="Cell">
                                                            <td height="90" width="130" style={{
                                                                border: "1px solid #d3d3d3"
                                                            }}>
                                                                <a href="#" style={{ lineHeight: "20px" }}>
                                                                    <img border="0" height="90" width="130" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                </a>
                                                            </td>
                                                            <td height="90" style={{ border: "1px solid #d3d3d3", }}>
                                                                <a href="#" className="tgallery" style={{ lineHeight: "20px" }}>
                                                                    Playground
                                                                </a>
                                                                <br />
                                                                (5 Photos)
                                                            </td>
                                                        </tr>
                                                        <tr className="Cell">
                                                            <td height="90" width="130" style={{
                                                                border: "1px solid #d3d3d3"
                                                            }}>
                                                                <a href="#" style={{ lineHeight: "20px" }}>
                                                                    <img border="0" height="90" width="130" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                </a>
                                                            </td>
                                                            <td height="90" style={{ border: "1px solid #d3d3d3", }}>
                                                                <a href="#" className="tgallery" style={{ lineHeight: "20px" }}>
                                                                    Playground
                                                                </a>
                                                                <br />
                                                                (5 Photos)
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>

                                                <div>
                                                    <p style={{ fontWeight: '500' }}>Playground</p>
                                                    <p className="mb-0 text-end">Show me  <span style={{ color: '#D54400' }}>18 </span> | 36  | 54  | 72 records per page </p>
                                                    <Table border="0" cellspacing="0" width="100%">
                                                        <tbody>
                                                            <tr className="Cell w-100" >
                                                                <td style={{
                                                                    border: "1px solid #d3d3d3"
                                                                }}>
                                                                    <a href="#" style={{ lineHeight: "20px" }}>
                                                                        <img border="0" height="100%" width="100%" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                    </a>
                                                                </td>
                                                                <td style={{
                                                                    border: "1px solid #d3d3d3"
                                                                }}>
                                                                    <a href="#" style={{ lineHeight: "20px" }}>
                                                                        <img border="0" height="100%" width="100%" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                    </a>
                                                                </td>
                                                                <td style={{
                                                                    border: "1px solid #d3d3d3"
                                                                }}>
                                                                    <a href="#" style={{ lineHeight: "20px" }}>
                                                                        <img border="0" height="100%" width="100%" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="Cell">
                                                                <td style={{
                                                                    border: "1px solid #d3d3d3"
                                                                }}>
                                                                    <a href="#" style={{ lineHeight: "20px" }}>
                                                                        <img border="0" height="100%" width="100%" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                    </a>
                                                                </td>
                                                                <td style={{
                                                                    border: "1px solid #d3d3d3"
                                                                }}>
                                                                    <a href="#" style={{ lineHeight: "20px" }}>
                                                                        <img border="0" height="100%" width="100%" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                    </a>
                                                                </td>
                                                                <td style={{
                                                                    border: "1px solid #d3d3d3"
                                                                }}>
                                                                    <a href="#" style={{ lineHeight: "20px" }}>
                                                                        <img border="0" height="100%" width="100%" src={classroom} style={{ border: "1px solid #000000" }} />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                    <p style={{ fontWeight: '500', marginTop: '10px' }}>1</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div >
            </div >
        </>
    )
}

export default Gallery;